import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../../../../material.module';
import {ToastService} from '../../../../services/layout/toast.service';
import {FilesService} from "../../../../services/objects/files.service";
import {IFileOptions} from "../../../../models/file-options.model";
import {Router} from "@angular/router";

@Component({
  selector: 'app-file-general-settings',
  templateUrl: './file-general-settings.component.html',
  styleUrls: ['./file-general-settings.component.scss'],
  imports: [MaterialModule, ReactiveFormsModule]
})
export class FileGeneralSettingsComponent implements OnInit {
    private snackBar = inject(ToastService);
    private filesService = inject(FilesService);
    private router = inject(Router);

  @Input() settingsForm!: FormGroup;
  @Input() file!: IFileOptions;
  @Output() filePublished = new EventEmitter<void>();

  selectedFile: File | null = null;
  isFileUploaded: boolean = false;
  isPublishing: boolean = false;

  ngOnInit(): void {
    if (!this.settingsForm) {
      throw new Error('settingsForm Input is required for FileGeneralSettingsComponent');
    }
  }

  /**
   * Handles file selection from the input.
   * @param event File selection event
   */
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.isFileUploaded = false; // Reset publish button state
      this.snackBar.showInfo(`Selected file: ${this.selectedFile.name}`, 3000);
    }
  }



  /**
   * Uploads the selected file using the FilesService.
   */
  uploadFile(): void {
    if (!this.selectedFile) {
      this.snackBar.showError('No file selected for upload.', 3000);
      return;
    }

    this.file.fileName = this.selectedFile.name;

    this.filesService.uploadFileAsync(this.file.id, this.selectedFile).subscribe({
      next: () => {
        this.isFileUploaded = true;
        this.snackBar.showSuccess('File uploaded successfully.', 3000);
      },
      error: (err) => {
        console.error('Upload failed', err);
        this.snackBar.showError('File upload failed.', 3000);
      }
    });
  }

  /**
   * Publishes the uploaded file using the FilesService.
   */
  publishFile(): void {
    if (!this.isFileUploaded) {
      this.snackBar.showError('Please upload a file before publishing.', 3000);
      return;
    }
    this.isPublishing = true;

    this.filesService.publishFileAsync(this.file).subscribe({
      next: () => {
        this.isPublishing = false;
        this.snackBar.showSuccess('File published successfully.', 3000);
        this.filePublished.emit();
      },
      error: (err) => {
        console.error('Publish failed', err);
        this.isPublishing = false;
        this.snackBar.showError('File publish failed.', 3000);
      }
    });
  }
}
